// ============================================================================
// Entity: ContactCodeTrees
// Key: contactCodeTrees
// Kind: entity
// Generated file. Do not edit manually.
// ============================================================================

import {
	contactCodeTreesCreate,
	getContactCodeTreesListQueryKey,
	getContactCodeTreesListQueryOptions,
} from '../api/backstage'
// #region Imports
import type {
	ContactCodeTreeSummary,
	CreateOrUpdateContactCodeTreeRequest,
	PagedResultOfContactCodeTreeSummary,
} from '../api/backstage.schemas'
import type { EntityConfig, ListQueryParams } from './entity-config.types'
import {
	defineMutationEndpoint,
	defineQueryEndpoint,
} from './entity-config.types'

// #endregion

// #region Entity Endpoints
const contactCodeTreesEntityEndpoints = {
	create: defineMutationEndpoint<
		ContactCodeTreeSummary,
		CreateOrUpdateContactCodeTreeRequest,
		undefined
	>({
		key: 'contactCodeTrees.create',
		method: 'POST',
		path: '/admin/contactcodetrees',
		mutationOptions: () => ({
			mutationFn: (variables: { data: CreateOrUpdateContactCodeTreeRequest }) =>
				contactCodeTreesCreate(variables.data),
		}),
		invalidates: [(_context) => getContactCodeTreesListQueryKey()],
	}),
	list: defineQueryEndpoint<
		PagedResultOfContactCodeTreeSummary,
		undefined,
		ListQueryParams
	>({
		key: 'contactCodeTrees.list',
		method: 'GET',
		path: '/admin/contactcodetrees',
		queryKey: (args) => getContactCodeTreesListQueryKey(args?.queryParams),
		queryOptions: (args) =>
			getContactCodeTreesListQueryOptions(args?.queryParams),
	}),
} as const
// #endregion

// #region Entity Config Export
export const contactCodeTreesEntityConfig = {
	key: 'contactCodeTrees',
	kind: 'entity',
	entity: {
		idField: 'id',
		routePath: '/contactCodeTrees',
	},
	endpoints: contactCodeTreesEntityEndpoints,
} as const satisfies EntityConfig<'contactCodeTrees'>
// #endregion
